import { render } from "./FailedList.vue?vue&type=template&id=b1742b5c"
import script from "./FailedList.vue?vue&type=script&lang=js"
export * from "./FailedList.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src3194113096/src/coop-web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__